// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { jettingAppToggleStyles } from "@stoneage/App/Components/JettingAppComponents/JettingAppToggle";
import IconTooltip from "@stoneage/XDL/Icons/IconTooltip";
import { color } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

jettingAppToggleStyles.container = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
    `,
};

jettingAppToggleStyles.label = {
    size: 14,
    weight: "bold",
    lineHeight: "24px",
};

jettingAppToggleStyles.error = {
    size: 14,
    weight: "normal",
    lineHeight: "24px",
    css: css`
        width: 100%;
        margin-top: 8px;
        text-align: right;
    `,
};

jettingAppToggleStyles.tooltip = {
    iconProps: {
        src: IconTooltip,
        color: "primary.main",
        size: 14,
        css: css`
            margin-left: 4px;
            &: hover {
                opacity: 0.33;
            }
        `,
    },
    cssOverrides: {
        tooltipClickable: css`
            display: inline;
            &[aria-expanded="true"] {
                ${IconWrapper} {
                    color: ${color("common.black")};
                }
            }
        `,
    },
};

jettingAppToggleStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
        background: ${color("common.white")};
        border: 1px solid ${color("common.ui7")};
        border-radius: 2px;
        height: 30px;
        padding: 1px;
    `,
};

jettingAppToggleStyles.button = {
    css: css`
        font-size: 14px;
        line-height: 22px;
        padding: 4px 10px;
        height: 26px;
        font-weight: bold;
        color: ${color("common.black")};
        opacity: 0.33;
        &.selected {
            background: ${color("primary.main")};
            opacity: 1;
            color: ${color("common.white")};
            border: 1px solid ${color("primary.main")};
            border-radius: 1px;
        }
    `,
};
